import { ref } from "vue";
import { defineStore } from "pinia";
import { useRuntimeConfig } from "#app";
import { useI18n } from "vue-i18n";

export const useClientServiceStore = defineStore("clientService", () => {

  const posts = ref([]);
  const categories = ref([]);

  const isLoading = ref(false);
  const error = ref(null);

  const fetchClientServiceData = async (categoryPath) => {
    isLoading.value = true;
    error.value = null;

    const config = useRuntimeConfig();
    const { locale } = useI18n();
    const baseApi = config.public.appApi; // Adjust based on your setup

    try {
      const response = await $fetch(
        `${baseApi}/${locale.value}/our-clients/${categoryPath}`
      );

      posts.value = response?.data || [];
    } catch (err) {
      error.value =
        err.message || "An error occurred while fetching the service data";
    } finally {
      isLoading.value = false;
    }
  };

  const fetchPortfolio = async () => {
    isLoading.value = true;
    error.value = null;

    const { locale } = useI18n();
    const { baseApi } = useApiBase(); // Adjust based on your setup

    try {
      const response = await $fetch(
        `${baseApi}/${locale.value}/our-clients/our-portfolio`
      );

      posts.value = response?.data || [];

    } catch (err) {
      error.value =
        err.message || "An error occurred while fetching the service data";
    } finally {
      isLoading.value = false;
    }
  };

  const fetchPortfolioGroup = async () => {
    isLoading.value = true;
    error.value = null;

    const { locale } = useI18n();
    const { baseApi } = useApiBase(); // Adjust based on your setup

    try {
      const response = await $fetch(
        `${baseApi}/${locale.value}/our-clients/service`
      );

      categories.value = response?.data || [];

    } catch (err) {
      error.value =
        err.message || "An error occurred while fetching the service data";
    } finally {
      isLoading.value = false;
    }
  };

  const fetchClientServiceByID = async (categoryPath, id) => {
    isLoading.value = true;
    error.value = null;

    const config = useRuntimeConfig();
    const { locale } = useI18n();
    const baseApi = config.public.appApi; // Adjust based on your setup

    try {
      const response = await $fetch(
        `${baseApi}/${locale.value}/our-clients/${categoryPath}/${id}`
      );

      posts.value = response?.data || [];
    } catch (err) {
      error.value =
        err.message || "An error occurred while fetching the service data";
    } finally {
      isLoading.value = false;
    }
  };

  return {
    posts,
    categories,
    isLoading,
    error,
    fetchPortfolio,
    fetchPortfolioGroup,
    fetchClientServiceData,
    fetchClientServiceByID,
  };
});
